<template>
    <div class="com-item companyOverview-module" :class="{ active: isactive == true }" :key="index">
        <div class="component person-nav">
            <div class="van-sticky" :style="{
                backgroundColor: W.bgColor || 'transparent',
                color: W.textColor || '#333'
            }">
                <div class="companyOverview-module__inner">
                    <div class="companyOverview-module__left">
                       
                        <div class="public-module_title" v-if="W.enTitle || W.cnTitle">
                            <h2 class="module-cn" v-if="W.cnTitle">{{ W.cnTitle }}</h2>
                            <div class="module-en" v-if="W.enTitle">
                                <p class="module-line"></p>
                                {{ W.enTitle }}
                            </div>
                        </div>

                        <div class="companyOverview-module__desc" v-html="W.describeHtml"></div>
                    </div>

                    <div class="companyOverview-module__right">
                        <div class="companyOverview-module__stats" v-if="W.stats && W.stats.length">
                            <div class="companyOverview-module__stat" v-for="(item, idx) in W.stats" :key="'s' + idx">
                                <div class="companyOverview-module__stat-icon">
                                    <img v-if="item.iconUrl" :src="item.iconUrl" alt="" />
                                </div>
                                <div class="companyOverview-module__stat-text">
                                    <p class="companyOverview-module__stat-number">
                                        <span class="num">{{ item.number }}</span><span class="unit" v-if="item.unit">{{ item.unit }}</span>
                                    </p>
                                    <p class="companyOverview-module__stat-title">{{ item.title }}</p>
                                    <p class="companyOverview-module__stat-en">{{ item.enSub }}</p>
                                </div>
                            </div>
                        </div>
                        
   

                        <div v-if="W.videoUrl" class="companyOverview-module__videoWrap">
                            <video
                                ref="video"
                                class="companyOverview-module__video"
                                :src="W.videoUrl"
                                :poster="W.videoPoster || ''"
                                :controls="playStatus"
                                width="100%"
                                height="100%"
                                playsinline
                            ></video>
                            <div
                                v-show="!playStatus"
                                class="companyOverview-module__video-mask"
                                @click="changePlay"
                            >
                                <span class="companyOverview-module__video-icon">
                                    <i class="el-icon-caret-right" style="font-size: 36px; line-height: 60px;"></i>
                                </span>
                            </div>
                            <div v-if="(W.videoTitle || W.videoDesc) && !playStatus" class="companyOverview-module__videoOverlay">
                                <p class="companyOverview-module__videoTitle">{{ W.videoTitle }}</p>
                                <p class="companyOverview-module__videoDesc">{{ W.videoDesc }}</p>
                            </div>
                        </div>
                        <div v-else-if="W.videoPoster" class="companyOverview-module__videoWrap">
                            <img class="companyOverview-module__video" :src="W.videoPoster" alt="" />
                            <div v-if="W.videoTitle || W.videoDesc" class="companyOverview-module__videoOverlay">
                                <p class="companyOverview-module__videoTitle">{{ W.videoTitle }}</p>
                                <p class="companyOverview-module__videoDesc">{{ W.videoDesc }}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
const DEFAULT_IMG = 'https://aes-mall-1257403518.cos.ap-guangzhou.myqcloud.com/202607/ScreenShot_2026-07-03_152303_32803152310271.png'
const DEFAULT_VIDEO = 'https://aes-mall-1257403518.cos.ap-guangzhou.myqcloud.com/202606/556e07222514734.mp4'

export default {
    name: 'companyOverview-module',
    components: {},
    props: {
        index: { type: Number },
        type: { type: String, default: 'preview' },
        isactive: { type: Boolean, default: false },
        phoneWidth: { type: Number, default: 1280 },
        proportion: { type: Number, default: 1 },
        modata: {
            type: Object,
            default: function () {
                return {
                    WName: 'companyOverview',
                    Title: '公司概况',
                    MID: 33,
                    ModuleName: 'companyOverviewModule',
                    WContent: {}
                }
            }
        }
    },
    computed: {
        W: {
            get() { return this.modata.WContent || {} },
            set(val) { this.modata.WContent = val }
        }
    },
    data() {
        return {
            playStatus: false,
            defaultData: {
                bgColor: '',
                textColor: '',
                enTitle: 'COMPANY PEOPLE',
                cnTitle: '公司概况',
                describeHtml: '<p>广州市安亿仕电子科技有限公司（AES）成立于2003年，坐落于广州市白云区，是集研发、设计、生产、销售于一体的全球化汽车照明模组制造服务商，专注车灯升级领域23年。</p><p>AES 持续为全球车灯改装门店、贸易商提供标准化车灯升级成品，同时开放 OEM、ODM 定制加工服务；企业先后获得高新技术企业、专精特新中小企业，是国内汽车照明改装行业标杆品牌。</p>',
                stats: [
                    { iconUrl: DEFAULT_IMG, number: '23', unit: '年', title: '行业炭精经验', enSub: 'SINCE 2003' },
                    { iconUrl: DEFAULT_IMG, number: '10000+', unit: 'm²', title: '智能制造基地', enSub: 'SMART FACTORY' },
                    { iconUrl: DEFAULT_IMG, number: '1000+', unit: '', title: '核心专利技术', enSub: 'PATENT TECHNOLOGY' },
                    { iconUrl: DEFAULT_IMG, number: '110+', unit: '', title: '覆盖国家与地区', enSub: 'GLOBAL COVERAGE' }
                ],
                videoUrl: DEFAULT_VIDEO,
                videoPoster: DEFAULT_IMG,
                videoTitle: 'AES 安亿仕企业宣传片 | 广州汽车 LED 激光透镜生产厂家',
                videoDesc: '本视频展示 AES 安亿仕广州生产基地实景、研发实力及核心产品，企业专注车灯升级领域23年，是国内汽车照明改装行业标杆品牌。'
            }
        }
    },
    mounted() {
        if (!this.modata.WContent) {
            this.$set(this.modata, 'WContent', {})
        }
        this.modata.WContent = Object.assign({}, this.defaultData, this.modata.WContent)
        if (!Array.isArray(this.modata.WContent.stats) || !this.modata.WContent.stats.length) {
            this.$set(this.modata.WContent, 'stats', JSON.parse(JSON.stringify(this.defaultData.stats)))
        }
    },
    methods: {
        changePlay() {
            if (!this.$refs.video) return
            if (this.playStatus) this.$refs.video.pause()
            else this.$refs.video.play()
            this.playStatus = !this.playStatus
        }
    },
    watch: {},
    filters: {}
}
</script>

<style scoped lang="scss">

.companyOverview-module {
    margin-bottom: 30px;
    .van-sticky {
        width: 94%;
        max-width: 1600px;
        margin: 0 auto;
        padding: 2% 0;
    }

    .companyOverview-module__inner {
        display: flex;
        flex-wrap: wrap;
        align-items: flex-start;
    }

    .companyOverview-module__left {
        flex: 0 0 38%;
        max-width: 38%;
        box-sizing: border-box;
        padding-right: 4%;
    }

    .companyOverview-module__right {
        flex: 1;
        min-width: 0;
    }


    .companyOverview-module__desc {
        padding-top: 10px;
        font-size: 18px;
        color: #555;
        line-height: 2.2;
        margin: 0;

        ::v-deep p {
            margin: 0 0 16px;
            text-indent: 2em;
        }
    }

    .companyOverview-module__stats {
        display: flex;
        flex-wrap: wrap;
        margin-bottom: 24px;
    }

    .companyOverview-module__stat {
        flex: 0 0 25%;
        max-width: 25%;
        box-sizing: border-box;
        padding-right: 8px;
      /*  display: flex;
        align-items: flex-start;*/
    }

    .companyOverview-module__stat-icon {
        width: 36px;
        height: 36px;
        flex: none;
        margin-bottom: 6px;
        display: flex;
        align-items: center;
        justify-content: center;

        img {
            max-width: 100%;
            max-height: 100%;
        }
    }

    .companyOverview-module__stat-text {
        flex: 1;
        min-width: 0;
    }

    .companyOverview-module__stat-number {
        margin: 0 0 6px;
        line-height: 1.1;

        .num {
            font-size: 24px;
            font-weight: bold;
            color: #e60012;
            margin-right: 2px;
        }
        .unit {
            font-size: 14px;
            color: #e60012;
        }
    }

    .companyOverview-module__stat-title {
        font-size: 14px;
        font-weight: bold;
        color: #333;
        line-height: 1.4;
        margin: 0 0 2px;
    }

    .companyOverview-module__stat-en {
        font-size: 11px;
        color: #999;
        letter-spacing: 1px;
        line-height: 1.4;
        margin: 0;
    }

    .companyOverview-module__videoWrap {
        position: relative;
        min-height: 300px;
        width: 100%;
        max-width: 1600px;
        margin: 3% auto 0;

        video {
            display: block;
            width: 100%;
            max-height: 34vw;
            background: #000;
        }

        img {
            display: block;
            width: 100%;
            max-height: 34vw;
            border-radius: 20px;
            background: #000;
            object-fit: cover;
        }
    }

    .companyOverview-module__video-mask {
        position: absolute;
        inset: 0;
        background-color: rgba(255, 255, 255, 0.1);
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        border-radius: 20px;
    }

    .companyOverview-module__video-icon {
        width: 60px;
        height: 60px;
        border-radius: 30px;
        text-align: center;
        border: 2px solid #fff;
        color: #fff;
        // box-shadow: 0 0 10px #dedede;
        cursor: pointer;
    }

    .companyOverview-module__videoOverlay {
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
        padding: 12px 20px;
        background: linear-gradient(to top, rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0));
        color: #fff;
        pointer-events: none;
    }

    .companyOverview-module__videoTitle {
        font-size: 16px;
        font-weight: bold;
        line-height: 1.4;
        margin: 0 0 4px;
    }

    .companyOverview-module__videoDesc {
        font-size: 12px;
        line-height: 1.6;
        margin: 0;
        opacity: 0.85;
    }
}

@media screen and (max-width: 768px) {
    .companyOverview-module {
        margin-bottom: 5px;
        .public-module_title{
            margin-bottom: 10px;
        }
        .companyOverview-module__inner {
            flex-direction: column-reverse;
        }

        .companyOverview-module__left {
            flex: 0 0 98%;
            max-width: 98%;
            padding-right: 0;
            margin-bottom: 0;
        }

        .companyOverview-module__right {
            flex: 0 0 100%;
            width: 100%;
        }
        .companyOverview-module__stats{
            width: 90%;
            margin-left: auto;
            margin-right: auto;
        }

        .companyOverview-module__stat {
            flex: 0 0 50%;
            max-width: 50%;
            margin:0 0 16px;
        }
        .companyOverview-module__stat-title{
            font-size: 18px;
        }
        .companyOverview-module__stat-en{
            font-size: 14px;
        }

        .companyOverview-module__videoWrap {
            min-height: 0;
            max-height: none;
            height: auto;
            width: 100%;
            margin: 0 0 3%;

            video,
            img {
                max-height: 60vw;
            }
        }
    }
}
</style>